export enum PopupButtons {
  YesNo = 'YesNo',
  YesNoCancel = 'YesNoCancel',
  Ok = 'Ok',
}
